var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterRightLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 434,
    viewBox: "0 0 375 434",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.778 339.083L374.291 226.262L326.977 197.214L178.463 280.396L1.03629 181.37V235.41L179.778 339.083Z",
    fill: "#F5A011"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179.835 375.884L374.291 264.171V321.377L179.778 433.679L0.000183105 329.885V272.057L179.835 375.884Z",
    fill: "#F5A011"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M324.347 161.716L276.645 131.476L178.592 191.955L139.119 169.449L267.37 95.9776L219.668 65.4327L88.4886 140.581L53.3831 120.565L207.743 30.2395L157.391 0L1.03537 90.7186V143.309L179.917 244.455L324.347 161.716Z",
    fill: "#F5A011"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterRightLogo);
export default __webpack_public_path__ + "static/media/footer-right-logo.3c1271458f8233db9910c99ce0d647c5.svg";
export { ForwardRef as ReactComponent };